import React from 'react';
import useIsMobile from 'tradera-hooks/use-is-mobile';

import styles from './site-subheader.module.scss';

const SiteSubheader = ({ className, children, ...otherProps }) => {
    const responsiveClassNames = useIsMobile() ? '' : 'bg-gray-100 border-top';
    return (
        <div
            className={`${
                styles.siteSubheader
            } ${responsiveClassNames} border-bottom ${className || ''}`}
            {...otherProps}>
            <div className="site-width px-2 px-md-1 px-lg-0 px-xl-1 h-100 d-flex align-items-center">
                {children}
            </div>
        </div>
    );
};

export default SiteSubheader;
